// Classes.
import { BookItem } from './bookItem';
import { Interpretation } from './interpretation';


export class Article extends BookItem {

  public text: string;
  public law: string;
  public more: boolean;
  public interpretations: Interpretation[];
  public rawText: string;
  public hasTokens: boolean;
  public translated: boolean;
  public lastUpdate: string;

  constructor(rawArticle: any) {
    super(rawArticle);
    this.law = rawArticle.law;
    this.more = rawArticle.more;
    this.text = rawArticle.text;
    this.rawText = rawArticle.text;
    this.translated = rawArticle.translated === "1";
    // Processed values.
    this.interpretations = rawArticle.interpretations ? rawArticle.interpretations.map(rawInterpretation => new Interpretation(rawInterpretation)) : [];

    // By default we assume there are no tokens.
    this.hasTokens = false;
  }

  /**
   * Get article's subarticles.
   */
  get subarticles(): Article[] {
    return <Article[]>this.children;
  }

  public get elemId(): string {
    return 'article-' + this.id;
  }
}
